export default "__VITE_ASSET__D9mq5kK1__"